import React from "react";
import { log as pilog } from "@limitless/common/utils";

const styles = {
    container: {
        height: "100vh",
        backgroundColor: "#f0f4f8",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "#22303c",
        textAlign: "center",
        lineHeight: 1.6
    },
    heading: { fontSize: "28px", fontWeight: "700", marginBottom: "16px" },
    message: { fontSize: "18px", marginBottom: "20px", maxWidth: "480px" },
    button: {
        backgroundColor: "#0070f3",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        padding: "12px 28px",
        fontSize: "16px",
        fontWeight: "600",
        cursor: "pointer",
        boxShadow: "0 4px 14px rgba(0, 112, 243, 0.3)",
        transition: "background-color 0.3s ease"
    },
    buttonHover: { backgroundColor: "#005fcc" },
    supportLink: {
        marginTop: "24px",
        fontSize: "14px",
        color: "#0070f3",
        textDecoration: "underline",
        cursor: "pointer"
    },
    errorMessage: { color: "red", fontSize: "16px", marginTop: "12px", maxWidth: "480px", wordBreak: "break-word" }
};

export default function fallbackRender({ error, errorInfo }) {
    return (
        <div style={styles.container} role="alert">
            <h1 style={styles.heading}>Oops! Something Went Wrong</h1>
            <p style={styles.message}>
                Our team is already looking into this issue. Please try refreshing the page or contact support for help.
            </p>
        </div>
    );
}
